export default __webpack_public_path__ + "static/media/key_features_management.552e975e.svg";